export default "__VITE_ASSET__u4$SBgK4__"